import { render, staticRenderFns } from "./element.vue?vue&type=template&id=ab436c2a&scoped=true&"
import script from "./element.vue?vue&type=script&lang=js&"
export * from "./element.vue?vue&type=script&lang=js&"
import style0 from "./element.vue?vue&type=style&index=0&id=ab436c2a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab436c2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab436c2a')) {
      api.createRecord('ab436c2a', component.options)
    } else {
      api.reload('ab436c2a', component.options)
    }
    module.hot.accept("./element.vue?vue&type=template&id=ab436c2a&scoped=true&", function () {
      api.rerender('ab436c2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/modules/album_detail/element.vue"
export default component.exports